import { useState } from "react"
import axios from "axios"

const ZOHO_SUBSCRIBE_ENDPOINT = "/.netlify/functions/zoho-subscribe-newsletter"

interface ZohoSubscribeState {
  response?: any
  loading: boolean
  error?: any
}

export const useSubscribeToCRM = () => {
  const [state, setState] = useState<ZohoSubscribeState>({
    response: null,
    loading: false,
    error: null,
  })

  const submitForm = async (data: {
    email: string
    ip_address?: string
    consent_given?: boolean
    consent_text?: string
    consent_date_time?: string
  }) => {
    setState({ response: null, loading: true, error: null })

    try {
      const res = await axios.post(ZOHO_SUBSCRIBE_ENDPOINT, data, {
        headers: { "Content-Type": "application/json" },
      })

      setState({ response: res.data, loading: false, error: null })
    } catch (err: any) {
      const errorMsg = err.response?.data?.error || err.message
      setState({ response: null, loading: false, error: errorMsg })
    }
  }

  return [submitForm, state] as const
}
